"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormProvider = exports.FormConsumer = void 0;
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FormContext = /*#__PURE__*/function () {
  function FormContext(formData) {
    (0, _classCallCheck2.default)(this, FormContext);
    this.data = formData;
    this.subscriptions = [];
  }
  return (0, _createClass2.default)(FormContext, [{
    key: "setFormData",
    value: function setFormData(form) {
      this.data = form;
      this.subscriptions.forEach(function (f) {
        return f();
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(f) {
      this.subscriptions.push(f);
    }
  }]);
}();
var FormProvider = exports.FormProvider = /*#__PURE__*/function (_React$Component) {
  function FormProvider(p) {
    var _this;
    (0, _classCallCheck2.default)(this, FormProvider);
    _this = _callSuper(this, FormProvider, [p]);
    _this.formContext = new FormContext(_this.props.formContext);
    return _this;
  }
  (0, _inherits2.default)(FormProvider, _React$Component);
  return (0, _createClass2.default)(FormProvider, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(next) {
      // const {
      //   getFieldProps,
      //   getFieldValue,
      //   getFieldError,
      //   isFieldTouched,
      //   isFieldValidating,
      // } = next.formContext?.form;

      // debugger;

      // this.formContext.setFormData({
      //   form: {
      //     getFieldProps,
      //     getFieldValue,
      //     getFieldError,
      //     isFieldTouched,
      //     isFieldValidating,
      //   },
      // });

      this.formContext.setFormData(next.formContext);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.UNSAFE_restrictUpdates) {
        return false;
      }
      return true;
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        formContext: this.formContext
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.children);
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(FormProvider, "childContextTypes", {
  formContext: _propTypes.default.object
});
var FormConsumer = exports.FormConsumer = /*#__PURE__*/function (_React$Component2) {
  function FormConsumer() {
    (0, _classCallCheck2.default)(this, FormConsumer);
    return _callSuper(this, FormConsumer, arguments);
  }
  (0, _inherits2.default)(FormConsumer, _React$Component2);
  return (0, _createClass2.default)(FormConsumer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var formContext = this.context.formContext;
      if (formContext) {
        this.unmountStatus = false;
        formContext.subscribe(function () {
          if (!_this2.unmountStatus) {
            _this2.forceUpdate();
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmountStatus = true;
    }
  }, {
    key: "getContextData",
    value: function getContextData() {
      var formContext = this.context.formContext;
      if (formContext) return formContext.data;else return {};
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.getContextData());
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(FormConsumer, "contextTypes", {
  formContext: _propTypes.default.object
});